import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {urlJoin} from '../../../utils/urlJoin';
import {environment} from '../../../../environments/environment';


@Injectable()
export class BiblioService {


    constructor(private http: HttpClient) {
    }


    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }

    static get baseHaicop() {
        return urlJoin(environment.server.hostSource, 'haicop');
    }

    loadcard(id) {
        const resource = urlJoin(BiblioService.base, 'vLib', id);
        return this.http.get(resource);
    }

    loadDataHaicop(options) {
        const resource = urlJoin(BiblioService.baseHaicop, 'vLib', 'data');

        return this.http.post(resource, options);
    }


    loadcardForHaicop(id) {
        const resource = urlJoin(BiblioService.baseHaicop, 'vLib', id);
        return this.http.get(resource);
    }

    removeFAQFromList(data: any) {
        const resource = urlJoin(BiblioService.baseHaicop, 'vLib/delete?seqNo=' + data);
        return this.http.delete(resource);
    }

    loadcardAnnoncePublic(id) {
        const resource = urlJoin(BiblioService.baseHaicop, 'vLib', id);
        return this.http.get(resource);
    }

    getAcheteurPublic() {
        const resource = urlJoin(BiblioService.baseHaicop, 'vNoticeInst', 'instCode');
        return this.http.get(resource);
    }
}
